export const ENQUIRY_TYPE: { [index: string]: string } = {
  CLAIM_APPEAL: 'enquiry.type.CLAIM_APPEAL',
  COVERAGE: 'enquiry.type.COVERAGE',
  CONTACT_DETAIL_CHANGE: 'enquiry.type.CONTACT_DETAIL_CHANGE',
  CLAIM_REASON: 'enquiry.type.CLAIM_REASON',
  CLAIM_SETTLEMENT_NOTICE: 'enquiry.type.CLAIM_SETTLEMENT_NOTICE',
  CLAIM_STATUS: 'enquiry.type.CLAIM_STATUS',
  COMPLAINT: 'enquiry.type.COMPLAINT',
  E_SERVICES: 'enquiry.type.E_SERVICES',
  ENQUIRY_AND_FEEDBACK: 'enquiry.type.ENQUIRY_AND_FEEDBACK',
  MEDICAL_CARD: 'enquiry.type.MEDICAL_CARD',
  NETWORK_LIST: 'enquiry.type.NETWORK_LIST',
  PRE_AUTH_CASHLESS: 'enquiry.type.PRE_AUTH_CASHLESS',
  CLAIM_FORM_REQUEST: 'enquiry.type.CLAIM_FORM_REQUEST',
  SERVICE_REQUEST: 'enquiry.type.SERVICE_REQUEST',
  SHORTFALL: 'enquiry.type.SHORTFALL',
  SURGERY_CLASSIFICATION: 'enquiry.type.SURGERY_CLASSIFICATION',
  OTHER: 'enquiry.type.OTHER',
};

export type EnquiryTypeItemType = {
  label: string;
  value: string;
};
